module.exports = __webpack_public_path__ + "static/reddit-dea9f2b9e9904107306ad9632896b116.svg";